module.exports = __webpack_public_path__ + "static/8-574019dab6a74d980920097b09cca08d.jpg";